import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import React, { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AlertsContext from "common/providers/alerts";
import CategoryForm from "./CategoryForm";

function Category() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem('categories', id);

  useEffect(() => {
    if (error) {
      setAlert(error, 'danger');
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/categories");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataCategory: any) => {
      const category = { ...dataCategory };

      try {
        if (category.id) {
          await updateItem(category.id, category);
        } else {
          await saveItem(category);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <CategoryForm onSubmit={onSubmit} category={item} />
  );
}

export default Category;
